import { TYPE_COLLECTION } from './input-types';

export const id = 'requestedServiceMapped';
export const apiKey = 'RequestedServiceMapped';
export const type = TYPE_COLLECTION;

export const requestedServiceMapped = {
  id,
  apiKey,
  type,
};
